import React, { Component } from 'react'
import Icon from 'components/icon/icon'

import isEqual from 'react-fast-compare'

class Response extends Component {
	state = {
		isVisible: false
	}

	isFirst = true
	visibilityTimeout = null
	hasMounted = false

	componentWillMount(){
		this.hasMounted = true
		this.processData(null, true)
	}

	componentWillUpdate = nextProps => {
		if(!isEqual(this.props, nextProps)){
			this.processData(nextProps)
		}
	}

	componentWillUnmount() {
		this.hasMounted = false
	}

	processData = (nextProps = null) => {
		const {
			dismissCallback,
			timeout,
			response
		} = this.props

		let isShowing = !!((!response && nextProps && nextProps.response) || (response && !nextProps))

		if(response && nextProps && nextProps.response && !isEqual(response, nextProps.response)){
			isShowing = true
		}

		if(isShowing){
			this.setState({
				isVisible: true
			})

			clearTimeout(this.visibilityTimeout)

			this.visibilityTimeout = setTimeout(_ => {
				if(!this.props.pinned){
					this.setState({
						isVisible: false
					})

					setTimeout(_ => {
						if(this.hasMounted){
							dismissCallback()
						}
					},300)
				}
			}, timeout)
		}
	}

	render() {
		const {
			response,
			fullWidth,
			isAtTop
		} = this.props

		const {
			isVisible
		} = this.state

		let responseClass = 'validate-response '
		let iconName = ''

		if(response){
			responseClass += response.type

			switch(response.type){
				case 'error':
					iconName = "fe-alert-triangle"
				break
				case 'success':
					iconName = "check"
				break
				case 'notice':
					iconName = "fe-flag"
				break
			}
		}

		if(isVisible){
			responseClass += ' visible'
		}

		if(fullWidth){
			responseClass += ' full-width'
		}

		if(isAtTop){
			responseClass += ' at-top'
		}

		return (
			<span className={ responseClass }>
				<Icon name={ iconName } />
				<span>
					{ response ? response.message : null }
				</span>
			</span>
		);
	}
}

Response.defaultProps = {
	timeout: 3500
}

export default Response



// WEBPACK FOOTER //
// ./src/components/validations/validate-response.jsx